// TW 延伸支架（第二代)
// const stand_extension_kit = "36673306820763";
// const tw_bundle_id = "42823098532053";
// const tw_full_set_id = "39802531381403";
// const tw_wall_mount_id = "39802531348635";
// const tw_shb_id = "44161913192661";
// const tw_refurbished_id_1 = "39549247422619";
// const tw_refurbished_id_2 = "43461418811605";

// const referUrl = "https://static.getcubo.com/public/refer.js?v=3";

// 特殊數量限制 id (default is 5, special is 2)
const specificQuantityId =
  window.special_quantity_limit_product?.trim().split(",") || [];
// 整修品 id
const specificRefurbishId = window.refurbished_product?.trim().split(",") || [];
const standExtensionKitId = window.stand_extension_kit_id?.trim() || "";

const site = location.host.split(".")[0];
const currencyObj = {
  us: "$",
  au: "$",
  ca: "$",
  de: "€",
  fr: "€",
  jp: "¥",
  uk: "£",
  tw: "$",
  "cubo-test": "$",
};

// const switchButtons = {
//   wall_mount: "switch-wall-mount",
//   full_set: "switch-full-set",
//   "3_stand_set": "switch-full-set",
// };
// const setupButtons = {
//   wall_mount: "setup-wall-mount",
//   full_set: "setup-full-set",
//   "3_stand_set": "setup-full-set",
// };
// const templates = {
//   wall_mount: {
//     price: "template_wall_mount_price",
//     cover: "template_wall_mount_cover",
//     specs: "wall_mount_specs",
//     include: "template_wall_mount_include",
//   },
//   full_set: {
//     price: "template_full_set_price",
//     cover: "template_full_set_cover",
//     specs: "full_set_specs",
//     include: "template_full_set_include",
//   },
//   "3_stand_set": {
//     price: "template_full_set_price",
//     cover: "template_full_set_cover",
//     specs: "full_set_specs",
//     include: "template_full_set_include",
//   },
// };

window.referralScript = undefined;

function cloneTemplate(templateId, targetId) {
  const template = document.getElementById(templateId);
  const target = document.getElementById(targetId);
  if (template && target) {
    const clone = template.content.cloneNode(true);
    target.innerHTML = "";
    target.appendChild(clone);
  }
}

function getCookieValue(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

//
function extractGaValue(gaCookie) {
  if (gaCookie) {
    console.log("gacookie", gaCookie);
    let parts = gaCookie.split(".");
    return parts[2] + "." + parts[3];
  } else {
    return "";
  }
}

// cart_url
async function getCartInfo() {
  try {
    const country = document.getElementById("shop_domain").dataset.country;
    const response = await fetch(`/cart.js`);
    const data = await response.json();
    window.cartInfo = data;
    // console.log("update cart");
    checkCartQuantity();
    // revise cart count;
    rerenderCartDrawer(data, country);
  } catch (error) {
    console.error(`Error: ${error}`);
  }
}

function triggerLazyload() {
  var observer = lozad();
  observer.observe();
  console.log("triggerLazyload");

  const observerBg = lozad(".lozad-bg", {
    loaded: function (el) {
      const backgroundImage = el.getAttribute("data-background-image");
      el.style.backgroundImage = backgroundImage;
    },
  });
  observerBg.observe();
}

function open_video_modal(type = "youtube", src) {
  const templateIdMap = {
    youtube: "component-modal-iframe",
    mp4: "component-modal-video",
    ig: "component-modal-ig",
  };

  const temp = document.getElementById(templateIdMap[type]);
  const clon = temp.content.cloneNode(true);
  document.body.appendChild(clon);
  document.body.classList.add("overflow-hidden");

  videoModalHandlers[type](src);
}

function loadScript(src) {
  let script = document.createElement("script");
  script.src = src;
  script.async = false;
  document.body.append(script);
}

// Angel/bundle spec add toggle function
function bindSpecItemClickEvents() {
  console.log("run bindSpecItemClickEvents");
  document
    .querySelectorAll(".component-product-specs__item")
    .forEach((item) => {
      const description = item.querySelector(
        ".component-product-specs__item--description"
      );

      item.addEventListener("click", function () {
        const isActive = item.classList.toggle(
          "component-product-specs__item--active"
        );
        if (isActive) {
          description.style.height = `${description.scrollHeight}px`;
          description.style.marginTop = "10px";
        } else {
          description.style.height = "0";
          description.style.marginTop = "0";
        }
      });
    });
}

// function changeRouterForVariant(
//   default_product,
//   amazon_link,
//   variant_id,
//   product_angel_swiper,
//   show_amz_button
// ) {
//   const otherProduct =
//     default_product === "wall_mount" ? "full_set" : "wall_mount";
//   document
//     .getElementById(switchButtons[default_product])
//     .classList.add("product-angel-switch__button--active");

//   document
//     .getElementById(switchButtons[otherProduct])
//     .classList.remove("product-angel-switch__button--active");
//   document.getElementById(setupButtons[default_product]).click();

//   // Change price, cover, include and details
//   cloneTemplate(templates[default_product].price, "ProductPrice");
//   cloneTemplate(templates[default_product].cover, "angel-wrapper");
//   cloneTemplate(templates[default_product].include, "product-include");
//   allFeatureSwitchFeature(
//     "angel-specs-button",
//     "angel-all-feature-button",
//     "angel-detail-content",
//     templates[default_product].specs
//   );

//   // Angel add to cart
//   document.getElementById("angel_add_to_cart").dataset.variant_id = variant_id;
//   document.getElementById("angel_add_to_cart").dataset.autoAddedProduct =
//     auto_added_product;

//   // Change photo
//   document.getElementById("angel-wrapper").classList.add("swiper-wrapper");
//   product_angel_swiper.slideToLoop(0, 1000, false);
//   product_angel_swiper.updateSlides();
//   product_angel_swiper.pagination.render();
//   product_angel_swiper.pagination.update();

//   // Change amazon link
//   const amazonLink = document.getElementById("amazon_link");
//   amazonLink.href = amazon_link;
//   if (show_amz_button === undefined) {
//     if (amazonLink.dataset[`${default_product}Amz`] === "true") {
//       amazonLink.style.display = "flex";
//     } else {
//       amazonLink.style.display = "none";
//     }
//   } else {
//     amazonLink.style.display = show_amz_button ? "flex" : "none";
//   }
// }

// PRODUCT page  (ALL Feature Details)
function allFeatureSwitchFeature(
  add_active_id,
  remove_active_id,
  target_id,
  copy_id
) {
  document
    .getElementById(add_active_id)
    .classList.add("component-toggle--active");
  document
    .getElementById(remove_active_id)
    .classList.remove("component-toggle--active");

  cloneTemplate(copy_id, target_id);

  document.querySelectorAll(".component-all-feature-card").forEach((item) => {
    item.addEventListener("click", () => {
      item.classList.toggle("component-all-feature-card-active");
    });
  });

  triggerLazyload();
}

// OPEN VIDEO COMPONENT

const videoModalHandlers = {
  youtube: (src) => {
    const iframe = document.getElementById("component-iframe");
    iframe.src = `https://www.youtube.com/embed/${src}?enablejsapi=1`;
  },
  mp4: (src) => {
    const source = document.querySelector("#component-video > source");
    source.src = src;
  },
  ig: (src) => {
    const iframeContainer = document.getElementById("component-ig-iframe");
    const split_temp = src.split("/");
    const ig_id = split_temp[split_temp.length - 2];
    const iframeHTML = `
      <iframe
        class="instagram-media instagram-media-rendered"
        id="instagram-embed-0"
        src="https://www.instagram.com/p/${ig_id}/embed/captioned/?cr=1&amp;v=14&amp;wp=540&amp;rd=http%3A%2F%2F127.0.0.1%3A3000&amp;rp=%2Fpages%2Ffeature-safety#%7B%22ci%22%3A0%2C%22os%22%3A6441.300000011921%2C%22ls%22%3A6423.600000008941%2C%22le%22%3A6436.800000011921%7D"
        allowtransparency="true"
        allowfullscreen="true"
        frameborder="0"
        height="0"
        data-instgrm-payload-id="instagram-media-payload-0"
        scrolling="no"
        style="background: white; max-width: 540px; width: calc(100% - 2px); border-radius: 3px; border: 1px solid rgb(219, 219, 219); box-shadow: none; display: block; margin: 0px 0px 12px; min-width: 326px; padding: 0px;">
      </iframe>
      <script async src="//www.instagram.com/embed.js"></script>
    `;
    iframeContainer.innerHTML = iframeHTML;
  },
};

// loadScript("/article/script-async-defer/long.js");

// Component successful status
function component_signup_successful(id = "component-signup") {
  const container = document.getElementById(id);
  const content = document
    .getElementById("signup-success")
    .content.cloneNode(true);
  container.innerHTML = "";
  container.append(content);
}

async function sendUserInfo(email, name, birthday) {
  const site = location.host.split(".")[0];
  const headers = {
    "Content-Type": "application/json",
  };
  const sendData = {
    email,
    label: site,
    ...(name && { name }),
    ...(birthday && { birthday }),
  };
  if (window.ga_client_id) {
    sendData.ga_client_id = window.ga_client_id;
  }
  const URL = `https://us-central1-cubo-smart-baby-camera.cloudfunctions.net/shopify/customer/${site}`;

  try {
    const res = await fetch(URL, {
      method: "POST",
      headers,
      body: JSON.stringify(sendData),
    });
    if (res.status === 200) {
      return "success";
    } else {
      const text = await res.text();
      console.log("error", text);
      return "error";
    }
  } catch (error) {
    console.log(error);
    return "error";
  }
}

async function sendUserInfoById() {
  // specific mailchimp id
}

async function toggleCartDrawer(toggle = "active") {
  if (toggle === "active") {
    document.getElementById("cart-drawer").classList.add("cart-active");
  } else {
    document.getElementById("cart-drawer").classList.remove("cart-active");
  }
}

function checkCartQuantity() {
  // check max limit
  if (window.cartInfo.items.length > 0) {
    window.cartInfo.items.forEach((item) => {
      const buttons = document.querySelectorAll(
        `.add_to_cart[data-variant_id="${item.variant_id}"]`
      );

      if (buttons.length) {
        let maxQuality = 5;
        if (specificQuantityId.includes(String(item.variant_id))) {
          maxQuality = 2;
        }
        if (standExtensionKitId.includes(String(item.variant_id))) {
          maxQuality = 3;
        }
        const isDisabled = item.quantity >= maxQuality;
        buttons.forEach((btn) => (btn.disabled = isDisabled));
      }
    });
  }
}

async function changeQuantity(id, count = 0, type) {
  try {
    const country = document.getElementById("shop_domain").dataset.country;

    let quantity = count;
    if (type === "plus") {
      quantity++;
    } else if (type === "minus") {
      quantity--;
    }
    let maxQty = 5;
    if (standExtensionKitId.includes(String(id)) && country === "tw") {
      maxQty = 3;
    }
    if (
      specificRefurbishId.includes(String(id)) &&
      quantity >= 1 &&
      type === "plus"
    ) {
      console.log("整新品一次只能一個");
      return;
    }

    if (
      specificQuantityId.includes(String(id)) &&
      quantity > 2 &&
      type === "plus"
    ) {
      console.log("特定商品數量超過");
      return;
    }
    if (quantity > maxQty) {
      console.log("數量超過");
      return;
    }

    const reqData = { id, quantity };
    const response = await fetch(`/cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(reqData),
    });
    const data = await response.json();
    await rerenderCartDrawer(data, country);
    await getCartInfo();

    // 判斷整修品
    //若是購物車沒有整新品但頁面有整新品，需將整新品鎖住的按鈕打開
    if (
      specificRefurbishId.includes(String(id)) &&
      quantity === 0 &&
      document.querySelector(`.add_to_cart[data-variant_id="${id}"]`)
    ) {
      document.querySelector(
        `.add_to_cart[data-variant_id="${id}"]`
      ).disabled = false;
    }
  } catch (error) {
    console.log(`Error: ${error}`);
  }
}

function appendTemplateToCartDrawer(templateId) {
  const templateTemp = document.getElementById(templateId);
  const templateClone = templateTemp.content.cloneNode(true);
  document.getElementById("cart-drawer-list").appendChild(templateClone);
}

async function rerenderCartDrawer(obj, country = "us") {
  try {
    // status => increase / decrease / add / remove

    const cartDrawerCount = document.getElementById("cart-drawer-count");
    const cartDrawerList = document.getElementById("cart-drawer-list");
    const cartCount = document.getElementById("cart-count");
    const cartCheckout = document.getElementById("cart-checkout");

    cartDrawerCount.textContent = `${obj.item_count}`;
    // item render
    cartDrawerList.innerHTML = "";

    let wallMountId =
      document.getElementById("cart-drawer").dataset.wallMountSet || "";
    const fullSetId = document.getElementById("cart-drawer").dataset.fullSet;

    if (obj.items.length === 0 || !obj.items) {
      // Cart is empty
      appendTemplateToCartDrawer("cart-drawer-empty");
      cartCheckout.disabled = true;
      cartCount.classList.remove("nav-cart-main__count--nonempty");
    } else {
      obj.items.forEach((item, index) => {
        appendTemplateToCartDrawer("template-cart-item");
        const cartItems = document.querySelectorAll(".cart-item");
        const cartCountPlus = document.querySelectorAll(".cart-count-plus");

        const currentCartItem = cartItems[index];
        const currentCartCountPlus = cartCountPlus[index];

        currentCartItem.dataset.variant_id = item.variant_id;
        currentCartItem.dataset.quantity = item.quantity;

        // item cover
        document.querySelectorAll(".cart-item__img")[index].src = item.image;
        //item count
        document.querySelectorAll(".cart-item__num")[index].textContent =
          item.quantity;

        // Limit the number of products per order on the TW website

        const isStandExtensionKit = standExtensionKitId.includes(
          String(item.variant_id)
        );
        const isSpecificQuantity = specificQuantityId.includes(
          String(item.variant_id)
        );

        let quantityLimit = 5; // Default limit
        if (isSpecificQuantity) {
          quantityLimit = 2;
        } else if (isStandExtensionKit) {
          quantityLimit = 3;
        }

        if (item.quantity >= quantityLimit) {
          currentCartCountPlus.classList.add("disabled");
        } else if (currentCartCountPlus.classList.contains("disabled")) {
          currentCartCountPlus.classList.remove("disabled");
        }

        // 只要是整修品的品項就需 disable plus 按鈕
        if (specificRefurbishId.includes(String(item.variant_id))) {
          console.log("整修品");
          currentCartCountPlus.classList.add("disabled");
        }
        // item price (original)
        if (item.discounts.length !== 0) {
          document.querySelectorAll(".cart-item-modify__original")[
            index
          ].textContent = `${currencyObj[site]}${
            item.original_line_price / 100
          }`;
          // item discount price
          document.querySelectorAll(".cart-item-modify__price")[
            index
          ].textContent = `${currencyObj[site]}${item.line_price / 100}`;
          // item discount code
          let discount_title = "";
          for (const discount of item.discounts) {
            discount_title = discount.title + "<br>";
          }
          document.querySelectorAll(".cart-item-modify__discount")[
            index
          ].innerHTML = discount_title;
        } else {
          document.querySelectorAll(".cart-item-modify__price")[
            index
          ].textContent = `${currencyObj[site]}${item.line_price / 100}`;
        }

        // item select (To switch wall mount and full set)
        if (
          (item.variant_id === Number(wallMountId) ||
            item.variant_id === Number(fullSetId)) &&
          wallMountId
        ) {
          document.querySelectorAll(".cart-item-info__select")[index].value =
            String(item.variant_id);

          document
            .querySelectorAll(".cart-item-info__select")
            [index].addEventListener("change", async (e) => {
              // wall mount 39934784012457
              // full set 39934784045225
              let add_variant_id = e.target.value;

              let remove_variant_id;
              let target_index = index;
              if (e.target.value === wallMountId) {
                remove_variant_id = fullSetId;
              } else {
                remove_variant_id = wallMountId;
              }
              let count =
                document.querySelectorAll(".cart-item")[target_index].dataset
                  .quantity;
              await changeQuantity(remove_variant_id);

              await addToCart(add_variant_id, Number(count));
              await getCartInfo();
            });
        } else if (wallMountId) {
          document.querySelectorAll(".cart-item-info__select")[
            index
          ].style.display = "none";
        }

        // item name
        // console.log("item title", item.title);
        document.querySelectorAll(".cart-item-info__title")[index].textContent =
          item.title;
      });

      cartCount.classList.add("nav-cart-main__count--nonempty");

      // REMOVE
      document.querySelectorAll(".remove-from-cart").forEach((item, index) => {
        item.addEventListener("click", () => {
          const variant_id =
            document.querySelectorAll(".cart-item")[index].dataset.variant_id;
          changeQuantity(variant_id);
        });
      });
      // PLUS
      document.querySelectorAll(".cart-count-plus").forEach((item, index) => {
        item.addEventListener("click", () => {
          const variant_id =
            document.querySelectorAll(".cart-item")[index].dataset.variant_id;
          const quantity =
            document.querySelectorAll(".cart-item")[index].dataset.quantity;
          changeQuantity(variant_id, quantity, "plus");
        });
      });
      // MINUS
      document.querySelectorAll(".cart-count-minus").forEach((item, index) => {
        item.addEventListener("click", () => {
          const variant_id =
            document.querySelectorAll(".cart-item")[index].dataset.variant_id;
          const quantity =
            document.querySelectorAll(".cart-item")[index].dataset.quantity;
          changeQuantity(variant_id, quantity, "minus");
        });
      });
    }
    cartCheckout.disabled = false;
    cartCount.textContent = obj.item_count;
    if (document.getElementById("cart_total_price")) {
      document.getElementById("cart_total_price").textContent = `${
        currencyObj[site]
      }${obj.total_price / 100}`;
    }
  } catch (error) {
    console.error(`Error: ${error}`);
  } finally {
    document.getElementById("cart-count").classList.add("nav-cart-shake");
    setTimeout(() => {
      document.getElementById("cart-count").classList.remove("nav-cart-shake");
    }, 500);
  }
}

async function checkVariantAvailability(variant_id, useCache = true) {
  const now = Date.now();

  // 如果使用快取且快取未過期，直接返回結果
  if (
    useCache &&
    window.lastCheckTime[variant_id] &&
    now - window.lastCheckTime[variant_id] < window.CACHE_DURATION
  ) {
    return !window.unavailableProducts.has(variant_id);
  }

  try {
    const response = await fetch(`/products/${variant_id}?view=inventory`);
    const data = await response.json();
    const isAvailable =
      data.available &&
      (data.inventory_policy !== "deny" || data.inventory_quantity > 0);

    // 更新快取
    window.lastCheckTime[variant_id] = now;
    if (!isAvailable) {
      window.unavailableProducts.add(variant_id);
    } else {
      window.unavailableProducts.delete(variant_id);
    }

    return isAvailable;
  } catch (error) {
    console.error("Check variant error:", JSON.stringify(error));
    return false;
  }
}

async function addToCart(product_id, quantity = 1, autoAddedProduct = null) {
  let reqData = {
    items: [{ id: product_id, quantity }],
  };
  const productSet = new Set();
  if (autoAddedProduct) {
    // const isAutoAddedProductAvailable = await checkVariantAvailability(
    //   autoAddedProduct,
    //   true
    // );
    // if (isAutoAddedProductAvailable) {
    //   productSet.add(autoAddedProduct);
    // } else {
    //   console.log("auto-added product not available", autoAddedProduct);
    // }
    productSet.add(autoAddedProduct);
  }
  if (window.automatic_product_enable == "true") {
    const bundles = [
      {
        productList: window.automatic_product_x?.trim().split(",") || [],
        freeProduct: window.automatic_product_y?.trim(),
      },
      {
        productList: window.automatic_product_x_2?.trim().split(",") || [],
        freeProduct: window.automatic_product_y_2?.trim(),
      },
      {
        productList: window.automatic_product_x_3?.trim().split(",") || [],
        freeProduct: window.automatic_product_y_3?.trim(),
      },
      {
        productList: window.automatic_product_x_4?.trim().split(",") || [],
        freeProduct: window.automatic_product_y_4?.trim(),
      },
    ];

    for (const bundle of bundles) {
      if (
        bundle.productList.length > 0 &&
        bundle.freeProduct &&
        bundle.productList.includes(product_id)
      ) {
        productSet.add(bundle.freeProduct);

        // const isFreeProductAvailable = await checkVariantAvailability(
        //   bundle.freeProduct,
        //   true
        // );
        // if (isFreeProductAvailable) {
        //   productSet.add(bundle.freeProduct);
        // } else {

        //   console.log("free product not available", bundle.freeProduct);
        // }
      }
    }
  }

  for (const item of productSet) {
    reqData.items.push({ id: item, quantity });
  }
  const response = await fetch(`/cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(reqData),
  });

  const data = await response.json();

  console.log("add to cart", data);
}

window.addEventListener("DOMContentLoaded", async () => {
  console.log("DOM");

  let gaCookie = getCookieValue("_ga");
  console.log("gagaga", gaCookie, extractGaValue(gaCookie));
  window.ga_client_id = extractGaValue(gaCookie);

  const url = new URL(window.location);
  const urlSearch = new URLSearchParams(url.search);

  // 如果網址 ?discount= 代表有折扣碼
  const discountUrl = urlSearch.get("discount");
  if (discountUrl !== null) {
    sessionStorage.setItem("cuboai_discount", discountUrl);
  }

  // open cart
  const openCart = urlSearch.get("opencart");
  if (openCart !== null) {
    document.getElementById("cart-toggle")?.click();
  }

  // ADD TO CART
  if (document.querySelector(".add_to_cart")) {
    document.querySelectorAll(".add_to_cart").forEach((item) => {
      item.addEventListener("click", async (event) => {
        try {
          event.stopPropagation();
          event.preventDefault();
          const variantId = item.dataset.variant_id;
          const autoAddedProduct = item.dataset.autoAddedProduct || null;
          await addToCart(variantId, 1, autoAddedProduct);
          await getCartInfo();
          await toggleCartDrawer();
        } catch (error) {
          console.error(`Error: ${error}`);
        }
      });
    });
  }

  // Add discount code to session storage
  const cuboaiFamPromo = urlSearch.get("cuboai_fam_promo");
  if (cuboaiFamPromo !== null) {
    sessionStorage.setItem(
      "cuboai_fam_promo",
      urlSearch.get("cuboai_fam_promo")
    );
  }

  // FAQ Item Click event
  document.querySelectorAll(".component-faq__item").forEach((item) => {
    item.addEventListener("click", () => {
      item.classList.toggle("component-faq-active");
      item.children[1].style.height = item.classList.contains(
        "component-faq-active"
      )
        ? `${item.children[1].scrollHeight}px`
        : "0px";
    });
  });

  // 如果有 id=cart 就查詢購物車
  if (document.getElementById("cart")) {
    getCartInfo();
  }

  // Cart close event
  document.getElementById("cart-close")?.addEventListener("click", () => {
    document.getElementById("cart-drawer")?.classList.toggle("cart-active");
    getCartInfo();
  });

  // Cart blank event
  document.getElementById("cart-blank")?.addEventListener("click", () => {
    toggleCartDrawer("inactive");
    getCartInfo();
  });

  // service comparison table
  if (document.getElementById("service-show-more")) {
    document
      .getElementById("service-show-more")
      .addEventListener("click", () => {
        document
          .querySelector(".component-service-description__wording")
          .classList.add("component-service-description__wording--more");
        document
          .getElementById("service-show-more")
          .classList.add("hide-service-description");
        document
          .getElementById("service-show-less")
          .classList.remove("hide-service-description");
      });

    document
      .getElementById("service-show-less")
      .addEventListener("click", () => {
        document
          .querySelector(".component-service-description__wording")
          .classList.remove("component-service-description__wording--more");
        document
          .getElementById("service-show-more")
          .classList.remove("hide-service-description");
        document
          .getElementById("service-show-less")
          .classList.add("hide-service-description");
      });
  }

  // lazy loads elements with default selector as '.lozad'
  await triggerLazyload();
});
